import useMediaQuery from '@mui/material/useMediaQuery'

import Dialog from '@mui/material/Dialog'

import RSVPSheet from './RSVPSheet'

import {SlideTransition, FadeTransition} from '../../generics'



const RSVPSheetDialog = ({ eventID, rsvpToken, onClose, open }) => {
  const isXs = useMediaQuery('(max-width: 660px)')

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isXs}
      fullWidth
      scroll='body'
      PaperProps={{
        style: {
          width: 'auto',
          maxWidth: '100vw',
          boxShadow: 'none',
          background: 'transparent', 
        }
      }}
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(20px)',
          backgroundColor: 'rgba(0,0,0,0.6)'
        }
      }}
      TransitionComponent={isXs ? SlideTransition : FadeTransition}
    >
      <RSVPSheet eventID={eventID} token={rsvpToken} close={onClose} />
    </Dialog>
  )
}

export default RSVPSheetDialog